var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5Z",
    stroke: "#676767",
    strokeWidth: 1.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.568 17.5C16.568 18.6785 16.568 19.2678 16.9566 19.6339C17.3452 20 17.9706 20 19.2215 20C20.4724 20 21.0978 20 21.4864 19.6339C21.875 19.2678 21.875 18.6785 21.875 17.5C21.875 16.3215 21.875 15.7322 21.4864 15.3661C21.0978 15 20.4724 15 19.2215 15C17.9706 15 17.3452 15 16.9566 15.3661C16.568 15.7322 16.568 16.3215 16.568 17.5ZM16.568 17.5V14.9142C16.568 12.6223 18.2368 10.6786 20.5482 10M8.125 17.5C8.125 18.6785 8.125 19.2678 8.5136 19.6339C8.90219 20 9.52763 20 10.7785 20C12.0294 20 12.6548 20 13.0434 19.6339C13.432 19.2678 13.432 18.6785 13.432 17.5C13.432 16.3215 13.432 15.7322 13.0434 15.3661C12.6548 15 12.0294 15 10.7785 15C9.52763 15 8.9022 15 8.5136 15.3661C8.125 15.7322 8.125 16.3215 8.125 17.5ZM8.125 17.5V14.9142C8.125 12.6223 9.79387 10.6786 12.1053 10",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/Quotes.425ad53bf987a4e46205222f0d631cfa.svg";
export { ForwardRef as ReactComponent };